import { SimpleGrid } from '@chakra-ui/react'
import { ClipboardList, Hourglass, FileText, FileCheck } from 'lucide-react'
import { StatCard } from '@/components/client/StatCard'

type Props = {
  totalRequests?: number
  inProgress?: number
  openRequests?: number
  resolvedRequests?: number
}

export function ClientStatsRow({
  totalRequests = 0,
  inProgress = 0,
  openRequests = 0,
  resolvedRequests = 0,
}: Props) {
  return (
    <SimpleGrid
      templateColumns={{
        base: '1fr',
        sm: 'repeat(2, 1fr)',
        lg: 'repeat(4, 1fr)',
      }}
      gap={{ base: 4, md: 6, lg: '44px' }}
      justifyContent="start"
      w="100%"
      minW={0}
    >
      <StatCard
        label="Total Requests"
        value={Number(totalRequests)}
        variant="gray"
        icon={<ClipboardList size={16} />}
      />
      <StatCard
        label="In Progress"
        value={Number(inProgress)}
        variant="yellow"
        icon={<Hourglass size={16} />}
      />
      <StatCard
        label="Open Requests"
        value={Number(openRequests)}
        variant="blue"
        icon={<FileText size={16} />}
      />
      <StatCard
        label="Resolved Requests"
        value={Number(resolvedRequests)}
        variant="green"
        icon={<FileCheck size={16} />}
      />
    </SimpleGrid>
  )
}

export default ClientStatsRow
